import { reducers } from 'redux/core'
import { constants, requestWithMock } from 'helpers'


const fetch = () => (
  requestWithMock(constants.lscSchedules.cover)
    .then(({ data }) => {
      reducers.lscSchedules.summary.set({
        plannedTrips: data.scheduledRaces,
        problemCeils: data.problemCells,
        tripsCount: {
          planned: data.scheduledRacesYstrdy,
          actual: data.complitedRacesYstrdy,
        },
        kilometrage: {
          planned: data.scheduledMileageYstrdy,
          actual: data.mileageYstrdy,
        },
        breaks: data.breakdownsYstrdy,
        deviations: data.deviationsYstrdy,
      })
    })
)


export default {
  fetch,
}
